import { Component, Input, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { observeProperty } from '@lcms/shared/data-access-user';
import { map } from 'rxjs';

@Component({
  selector: 'lcms-answer-result',
  templateUrl: './answer-result.component.html',
  styleUrls: ['./answer-result.component.scss'],
})
export class AnswerResultComponent {
  @Input() cmpData:any;
  @Input() showDetails?:boolean;
  sanitizer=inject(DomSanitizer);
  data$ = observeProperty(this as AnswerResultComponent,'cmpData');
  
  getKeys(obj:any){
    return Object.keys(obj);
  }

  sanitize(term:string){
    return this.sanitizer.bypassSecurityTrustHtml(term);
  }
}
